import React from "react";
import { BsChevronLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

export default function BackTool({ actions }: any) {
  const navigate = useNavigate();
  return (
    <div className="border-b bg-white text-sm flex justify-between items-center px-4 hover:text-red-600">
      <div className="">
        <button
          onClick={() => navigate(-1)}
          className={`flex justify-center items-center py-2 `}
        >
          <BsChevronLeft />
          <span className="ml-1">Back</span>
        </button>
      </div>
      <div className="">{actions}</div>
    </div>
  );
}
